import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
//import { format } from "d3-format"
import CvdMikroCardssmall from '../../../../../components/Cards/CVDMikroCards_small';
import DiaOverview from "../InfoText/DiaOverview";
//import GETMICRO_2 from "./GETMICRO_2";
import MicroBarChart from "./MicroBarChart";

const micro_warning_low = 153;
const micro_warning_red = 115;


export default function MicroCard3(data) {

const diversity = data.data

return (
<>
<CvdMikroCardssmall  
  
content = {<>      

   <Grid container >  

    
         
            
                <Grid container >   
                        <Grid item xs={10}> <Typography variant="h3" color='common.white' sx={{p:1}}> REFERENCE&nbsp; </Typography>  </Grid>
                        <Grid item xs={2}> <DiaOverview/>   </Grid>
                </Grid>

    <Grid item xs={12} sx={{pl:4, pt:2,  alignItems: 'center', justifyContent: 'center', }}> <MicroBarChart />  </Grid> 

</Grid>
 
           
        </>}   
    />    
    </>
    )};
  